export default "__VITE_ASSET__5bc73fb8__"